import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, from, fromEvent, map, mergeMap, Observable, take } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class UserInteractionService {

  get onUserAction$(): Observable<boolean> {
    return this._onUserActionSubject
    .pipe(
      filter((v) => v),
      take(1)
    );
  }

  private _onUserActionSubject =  new BehaviorSubject(false);

  constructor(
    private platform: Platform
  ) {

    if (this.platform.isBrowser) {
      const events = [
        'scroll',
        'mousedown ',
        'mousemove',
        'touchstart',
        'keydown',
      ];
      from(events)
        .pipe(
          mergeMap(event => fromEvent(document, event)),
          map(() => true),
          take(1)
        ).subscribe(v => {
          this._onUserActionSubject.next(true);
        });
    }
  }
}
